import { render, staticRenderFns } from "./detailForm.vue?vue&type=template&id=562b59ce&"
import script from "./detailForm.vue?vue&type=script&lang=js&"
export * from "./detailForm.vue?vue&type=script&lang=js&"
import style0 from "./detailForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports